"use client";

import { useQuery } from "@tanstack/react-query";

import FetchError from "@/components/ui/fetch-error";
import Loading from "@/components/ui/loading";

import OverviewTable from "./overview-table";

import api from "@/lib/api";

type HarmonizedOverviewProps = {
  [studyName: string]: { value: number; label: string }[];
};

export default function OverviewHome() {
  const { data, error, isPending } = useQuery({
    queryKey: ["hrd-overview", "hcap"],
    queryFn: async () => {
      const params = new URLSearchParams({ site_name: "hcap" });
      return await api.get<HarmonizedOverviewProps>(`/hrd/overview/?${params.toString()}`);
    },
  });

  if (isPending) return <Loading />;
  if (error) return <FetchError message={error.message} />;
  return (
    <>
      <p className="g2-text-grey">
        Harmonized datasets are created to provide comparable research-ready variables. Variables are defined as
        similarly as possible across all waves and studies. Each dataset combines all available waves from each study;
        each individual is one record. All variables use intuitive variable names and study-specific variable names are
        used to indicate significant inter-study differences. Variables have been built to account for any survey skip
        pattern.
      </p>

      <h4 className="g2-header-navy">Overview</h4>
      <hr />
      <p className="g2-text-grey">Find information about each Harmonized HCAP dataset produced by the Gateway.</p>
      {data && Object.keys(data).length > 0 && <OverviewTable overviewData={data} />}
    </>
  );
}
